<main class="main-home-secton">
  <div class="event-main">
    <div class="container-fluid">
      <div class="div-header" mt-5>
        <h1>Explore CSR Project</h1>
      </div>
      <div class="tag-group">
        <div class="container-fluid">
          <div class="margin-set">
            <div class="row">
              <div
                class="col-lg-12 col-md-12 col-sm-12 col-12 mt-4"
                *ngIf="noData == false"
              >
                <div class="row">
                  <div
                    class="col-lg-4 col-md-6 col-sm-6 col-12"
                    *ngFor="let list of dataSource; let i = index"
                  >
                    <div class="events-div">
                      <div class="event-titles text-center">
                        <div class="ml-5">
                          <h5 class="incubatorName text-center name-card">
                            {{ list.projectName }}
                          </h5>
                        </div>
                        <div class="card card-incub-details">
                          <div class="incub-details-new">
                            <p>
                              <span class="sub-head">Incubator Name : </span
                              ><br />
                              <span>{{ list.name }}</span>
                            </p>
                            <p>
                              <span class="sub-head">Sector : </span
                              ><br /><span>{{ list.projectSector }}</span>
                            </p>
                            <p>
                              <span class="sub-head">Focused Districts :</span
                              ><br /><span>{{ list.districts }}</span>
                            </p>
                          </div>
                        </div>
                        <div class="mt-2">
                          <button
                            class="incubatorBtn"
                            (click)="viewCSRProject(list.id)"
                          >
                            Know More
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="pagination-div text-center m-3"
                  *ngIf="totalPages > 1"
                >
                  <button
                    mat-mini-fab
                    color="accent"
                    class="set-page mr-2"
                    [disabled]="currentPage == 1"
                    (click)="paginatePartList('prev')"
                  >
                    <i class="fas fa-chevron-left"></i>
                  </button>
                  <button
                    mat-mini-fab
                    color="accent"
                    class="set-page"
                    [disabled]="currentPage == totalPages"
                    (click)="paginatePartList('next')"
                  >
                    <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
              </div>
              <div
                class="col-lg-12 col-md-12 col-sm-12 col-12"
                *ngIf="noData == true"
              >
                <div class="text-center no-data-div">
                  <img
                    src="assets/images/startup-logo.png"
                    class="img-fluid"
                    alt=""
                  />
                  <h6>Coming Soon</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
